import React from 'react';

const AvatarCircle = ({children, index=0, indexProgress=0}) => {

    const cssClass = index > indexProgress ? 'sg-statusbar-bg' : 'sg-statusbar-bg-active';

    return (
        <div className={cssClass}>{children}</div>
    );
}

export default AvatarCircle;
